export default "__VITE_ASSET__2ed00fb9__"